function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.0847 1.98821L12.676 7.08676L16.5262 10.1458L11.6859 11.5296L9.88307 16.3601L7.30034 12.117L2.33345 12.0487L5.57774 8.04142L4.30997 3.1694L8.90114 4.93104L13.0847 1.98821Z",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M21.8492 21.7593C22.2685 22.1187 22.8998 22.0701 23.2593 21.6508C23.6187 21.2315 23.5701 20.6002 23.1508 20.2407L21.8492 21.7593ZM12.6508 11.2407C12.2315 10.8813 11.6002 10.9299 11.2407 11.3492C10.8813 11.7685 10.9299 12.3998 11.3492 12.7593L12.6508 11.2407ZM23.1508 20.2407L12.6508 11.2407L11.3492 12.7593L21.8492 21.7593L23.1508 20.2407Z",
  fill: "currentColor"
});

function SvgMagic(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon-magic",
    ref: svgRef
  }, props), _ref, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagic);
export default __webpack_public_path__ + "static/media/magic.7b3efa29.svg";
export { ForwardRef as ReactComponent };